import React from 'react';
import styles from '../styles/Aboutus.module.scss';
import Slider from 'react-slick';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import CustomImage from "./CustomImage";
import Card from 'react-bootstrap/Card';
import Recognition from './Recognition';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HistoryAbt from './Historyabtus';
import VisibilitySensorComponent from './VisibilitySensorComponent';
import FaqComponent from './PST/FrequentlyAskedQuestions';
import  Ratio  from 'react-bootstrap/Ratio';
import LazyMedia from './LazyMedia';

const AboutUs: React.FC = (props: any) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: false,
        },
      },
    ],
  };
  return (
    <>
      <div className={styles.edtech}>
        <Container>
          <div className={styles.breadcrum}>
            <Row className='text-center'>
              <Col lg={7} md={10} xs={12} className={styles.centered}>
                <Breadcrumb>
                  <Breadcrumb.Item style={{ opacity: 0.5 }} href='/'>
                    Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item href=''> About Us </Breadcrumb.Item>
                </Breadcrumb>
                <div id='abttop-content' className={styles.abttopContent}>
                  <h1>We are the fastest growing EdTech brand</h1>
                  <div className={styles.abttopContentMobile}>
                    <h2>
                      We help international students and recruitment partners
                      choose the best that global universities offer{' '}
                    </h2>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <Row>
                  <Col xs={12} md={12}>
                    <div id='parent-mainImg' className={styles.parentMain}>
                      <div className={styles.first}>
                        {/* <CustomImage
                          src={
                            props.aboutusData?.firstImage || '/kctech3930.svg'
                          }
                          alt={props.aboutusData?.firstImageAltTag || ''}
                          width={770}
                          height={500}
                        /> */}
                         <div className={styles.videoPanel}>
                            <div className={styles.videoPlaceholder}>
                                <Ratio aspectRatio='16x9' className={styles.customVideoHeight}>
                                  <LazyMedia tag='embed' type='image/svg+xml' src={props.aboutusData?.video?.videoLink} />
                                </Ratio>
                            </div>
                        </div>
                      </div>
                      <div className={styles.second}>
                        <div className={styles.childa}>
                          <CustomImage
                            src={
                              props.aboutusData?.secondImage || '/edtech2.svg'
                            }
                            alt={props.aboutusData?.secondImageAltTag || ''}
                            width={370}
                            height={195}
                          />
                        </div>
                        <div className={styles.childa}>
                          <CustomImage
                            src={
                              props.aboutusData?.thirdImage || '/edtech3.svg'
                            }
                            alt={props.aboutusData?.thirdImageAltTag || ''}
                            width={370}
                            height={195}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container>
        <Row id='our-visiontxtImg' className={styles.rowPadding}>
          <Col sm={2} className='text-center'>
            <CustomImage
              src={props.aboutusData?.visionImage?.imageUrl}
              width={133}
              height={120}
              alt={props.aboutusData?.visionImage?.alt}
            />
          </Col>
          <Col sm={10}>
            <h3 className={styles.subHeading}>Our Vision</h3>
            {props.aboutusData?.vision}
          </Col>
        </Row>
        <Row id='our-missiontxtImg' className={styles.rowPadding}>
          <Col sm={2} className='text-center'>
            <CustomImage
              src={props.aboutusData?.missionImage?.imageUrl}
              width={133}
              height={120}
              alt={props.aboutusData?.missionImage?.alt}
            />
          </Col>
          <Col sm={10}>
            <h3 className={styles.subHeading}>Our Mission</h3>
            {props.aboutusData?.mission}
          </Col>
        </Row>
        <Row id='our-storytxtImg' className={styles.rowPadding}>
          <Col sm={2} className='text-center'>
            <CustomImage
              src={props.aboutusData?.storyImage?.imageUrl}
              width={133}
              height={120}
              alt={props.storyImage?.missionImage?.alt}
            />
          </Col>
          <Col sm={10}>
            <h3 className={styles.subHeading}>Our Story</h3>
            {props.aboutusData?.story}
          </Col>
        </Row>
      </Container>
      {/* Our history */}

      {props.aboutusData?.history?.length > 0 && (
        <div className={styles.histbg}>
          <Container>
            <Row>
              <Col>
                <HistoryAbt data={props.aboutusData?.history} />
              </Col>
            </Row>
          </Container>
        </div>
      )}

      <Container>
        <Row>
          <Col>
            {/* Brief History Section */}
            <div id='brief-history' className={styles.briefHistory}>
              <div className={styles.containBg}>
                <Row className='text-center'>
                  <Col xs={12} md={4} lg={4}>
                    <div className={styles.historySec}>
                      <h2 className={styles.foundedIn}>
                        {props.aboutusData?.foundedYear}
                      </h2>
                      <h3>Founded In</h3>
                    </div>
                  </Col>
                  <Col xs={12} md={4} lg={4}>
                    <div className={styles.historySec}>
                      <h2
                        className={styles.tieups}
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <VisibilitySensorComponent
                          end={props.aboutusData?.noOfUniversities}
                        />
                        +
                      </h2>
                      <h3>Global University Tie-ups</h3>
                    </div>
                  </Col>
                  <Col xs={12} md={4} lg={4}>
                    <div className={styles.historySec}>
                      <h2
                        className={styles.studplaced}
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <VisibilitySensorComponent
                          end={props.aboutusData?.studentsPlaced}
                        />
                        +
                      </h2>
                      <h3>Students Assisted</h3>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {/* Our Leadeships */}
            <div id='our-leadership' className={styles.ourleadership}>
              <h2 className={styles.mainTitle}>
                {props.aboutusData?.leadershipTitle}
              </h2>
              <Row className='d-flex justify-content-center'>
                {props.aboutusData?.founderCards?.length > 0 &&
                  props.aboutusData?.founderCards.map((card: any) => {
                    return (
                      <Col xs={12} md={4} key={card.id}>
                        <Card className={styles.leaderFirst}>
                          <a target='_blank' href={card.linkedinUrl || '/'}>
                            <div className={styles.lindin}>
                              <CustomImage
                                src='/new-images/linkedin.svg'
                                width={48}
                                height={48}
                                alt='EdTech1'
                              />
                            </div>
                          </a>
                          <CustomImage
                            src={card.imageUrl}
                            height={373}
                            width={400}
                            layout='responsive'
                            alt={card.imageAltTag}
                            className={styles.leaderImg}
                          />
                          <Card.Body>
                            <Card.Title className={styles.subTitle}>
                              {card.name}
                            </Card.Title>
                            <Card.Text className={styles.cardSmalltext}>
                              {card.position}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
              </Row>
              <Row>
                {props.aboutusData?.otherLeaders?.length > 0 &&
                  props.aboutusData?.otherLeaders.map((card: any) => {
                    return (
                      <Col xs={12} md={4} key={card.id}>
                        <Card className={styles.cardCust}>
                          <a target='_blank' href={card.linkedinUrl || '/'}>
                            <div className={styles.lindin}>
                              <CustomImage
                                src='/new-images/linkedin.svg'
                                width={48}
                                height={48}
                                alt='EdTech1'
                              />
                            </div>
                          </a>
                          <CustomImage
                            src={card.imageUrl}
                            height={250}
                            width={250}
                            layout='responsive'
                            alt={card.imageAltTag}
                            className={styles.leaderImg}
                          />
                          <Card.Body>
                            <Card.Title className={styles.subTitle}>
                              {card.name}
                            </Card.Title>
                            <Card.Text className={styles.cardSmalltext}>
                              {card.position}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
      {/* Our Recongnitions */}

      <div className={styles.recongnitionMain}>
        <Recognition bgColor='FBBFB6' />
      </div>

      {/* Partner with us */}
      <div id='partner-main' className={styles.partnerMain}>
        <Container>
          <h2 className={styles.mainTitle}>
            {props.aboutusData?.partnerWithTitle}
          </h2>
          <Row className='text-center'>
            {props.aboutusData?.partnerWithUs.map(
              (partner: any, index: number) => {
                return (
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className={styles.partnerSection}
                    key={index}
                  >
                    <div>
                      <div className={styles.partnerImg}>
                        <CustomImage
                          src={partner.imageUrl}
                          width={105}
                          height={76}
                          alt={partner.imageAltTag}
                        />
                      </div>
                      <h3>{partner.title}</h3>
                      <p>{partner.description}</p>
                    </div>
                    <span>
                      <a href={partner.link.href} className={styles.viewMore}>
                        {partner.link.label}{' '}
                      </a>
                    </span>
                  </Col>
                );
              }
            )}
          </Row>
        </Container>
      </div>
      {/* Our Offices */}
      <div id='our-offices' className={styles.purplebgOurOffices}>
        <Container>
          <h3 className={styles.mainTitle}> Our Offices</h3>
          <div className='d-none d-sm-block'>
            <Row>
              {props.aboutusData.officesKc.map((office: any, index: number) => {
                return (
                  <Col xs={12} md={6} key={index}>
                    <Card className={styles.cardCustOff}>
                      <Card.Body>
                        <Card.Title>{office.title}</Card.Title>
                        <Card.Text>
                          <p>{office.address}</p>
                          <div className={styles.info}>
                            <div className={styles.contactImg}>
                              <CustomImage
                                src='/new-images/phone-icon.svg'
                                width={38}
                                height={18}
                                alt='phoneIco'
                                className={styles.icon}
                                objectFit='contain'
                              /></div>
                            <span>{office.mobile}</span>
                          </div>
                          <div className={styles.info}>
                            <div className={styles.contactImg}>
                              <CustomImage
                                src='/new-images/email-icon.svg'
                                width={45}
                                height={18}
                                alt='emailIco'
                                className={styles.icon}
                                objectFit='contain'
                              /></div>
                            <span>{office.email}</span>
                          </div>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            <div className='text-center'>
              <span>
                <a href={'/contact-us'} className={styles.viewMore}>
                  Explore{' '}
                </a>
              </span>
            </div>
          </div>

          <div className='d-block d-sm-none'>
            <Slider {...settings}>
              <div>
                {props.aboutusData.officesKc.map(
                  (office: any, index: number) => {
                    return (
                      <Row key={index}>
                        <Col xs={12} md={6}>
                          <Card className={styles.cardCustOff}>
                            <Card.Body className={styles.crdbody}>
                              <Card.Title className={styles.carsubTitle}>
                                {office.title}
                              </Card.Title>
                              <Card.Text>
                                <p>{office.address}</p>
                                <div className={styles.info}>
                                  <div className={styles.contactImg}>
                                  <CustomImage
                                      src='/new-images/phone-icon.svg'
                                      width={38}
                                      height={18}
                                      alt='phoneIco'
                                      className={styles.icon}
                                    />
                                  </div>
                                  {office.mobile}
                                </div>
                                <div className={styles.info}>
                                  <div className={styles.contactImg}>
                                     <CustomImage
                                      src='/new-images/email-icon.svg'
                                      width={45}
                                      height={18}
                                      alt='emailIco'
                                      className={styles.icon}
                                    />
                                  </div>
                                 {office.email}
                                </div>
                              </Card.Text>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    );
                  }
                )}
              </div>
            </Slider>
            <div className='text-center'>
              <span>
                <a href={'/contact-us'} className={styles.viewMore}>
                  Explore{' '}
                </a>
              </span>
            </div>
          </div>
        </Container>
      </div>
      <div className={styles.purpleSection}>
        <div id='learn-abtkcedu' className={styles.LearnAbtKcEdu}>
          <Container>
            <h2 className={styles.mainTitle}>
              {props.aboutusData?.learnMoreTitle}
            </h2>
            <Row className='text-center'>
              {props.aboutusData?.learnMore?.length > 0 &&
                props.aboutusData?.learnMore.map(
                  (learn: any, index: number) => {
                    return (
                      <Col xs={12} md={4} lg={4} key={index}>
                        <div className={styles.learnText}>
                          <div className={styles.iconSetting}>
                            <CustomImage
                              src={learn.imageUrl}
                              width={130}
                              height={130}
                              alt={learn.imageAltTag}
                            />
                          </div>
                          <h3>{learn.title}</h3>
                          <p>{learn.description}</p>
                        </div>
                        <span>
                          <a href={learn.link.href} className={styles.viewMore}>
                            {learn.link.label}{' '}
                          </a>
                        </span>
                      </Col>
                    );
                  }
                )}
            </Row>
          </Container>
        </div>
      </div>
      {props.aboutusData?.faq &&
        <FaqComponent {...props.aboutusData.faq} />
      }
      <div>
        <Container>
          <Row>
            <Col xs={12} md={12}>
              <Card id='testimonials' className={styles.testimonialbg}>
                <Card.Body className={styles.cardBody}>
                  <Row className={styles.rowPaddingBot}>
                    <Col
                      sm={2}
                      md={3}
                      xs={12}
                      className={styles.imgFixedBottom}
                    >
                      <CustomImage
                        src={props.aboutusData?.ceoImageUrl}
                        width={186}
                        height={186}
                        alt={props.aboutusData?.ceoImageAltTag}
                      />
                    </Col>
                    <Col sm={10} md={9} xs={12}>
                      <div className={styles.uptag}>
                        {props.aboutusData?.ceoMessage}
                        <div className={styles.smalltext}>
                          - Pankaj Agrawal, Co-Founder & CEO
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AboutUs;
